import { format, parse, parseISO } from 'date-fns'

export const dateToString = date => {
  if (!date) {
    return ''
  }

  try {
    return format(parseISO(date), 'EEEE, MMM d, y')
  } catch (e) {
    return ''
  }
}

export const timeToString = (time, sourceTimeFormat = 'HH:mm') => {
  if (!time) {
    return ''
  }
  const formattedTime = time.replace('T ', '').replace(' ', '')

  try {
    return format(parse(formattedTime, sourceTimeFormat, new Date()), 'h:mm aaaa')
  } catch (e) {
    return ''
  }
}
